import {IExternalReference} from './i-external-reference';

export class ExternalReference {
    public constructor(public type: string,
                       public url: string) {
    }

    public static fromInterface(iExternalReference: IExternalReference): ExternalReference {
        return new ExternalReference(iExternalReference.type, iExternalReference.url);
    }
}
